import React from 'react';
import { Popconfirm, PopconfirmProps } from 'antd';
import { CustomComponentProps } from '../types';

export interface MyPopconfirmProps extends Omit<PopconfirmProps, 'onConfirm' | 'onCancel' | 'title'> {
  title?: React.ReactNode;
  description?: React.ReactNode;
  okText?: string;
  cancelText?: string;
  okType?: 'primary' | 'danger' | 'dashed' | 'link' | 'text' | 'default';
  cancelButtonProps?: any;
  okButtonProps?: any;
  icon?: React.ReactNode;
  showCancel?: boolean;
  onConfirm?: (e?: React.MouseEvent<HTMLElement>) => void | Promise<void>;
  onCancel?: (e?: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
  children?: React.ReactNode;
}

/**
 * MyPopconfirm - Confirmation popup
 * Perfect for delete actions, confirmations, etc.
 */
const MyPopconfirm: React.FC<MyPopconfirmProps> = ({
  title = 'Are you sure?',
  description,
  okText = 'Yes',
  cancelText = 'No',
  okType = 'primary',
  cancelButtonProps,
  okButtonProps,
  icon,
  showCancel = true,
  onConfirm,
  onCancel,
  disabled = false,
  children,
  ...rest
}) => {
  return (
    <Popconfirm
      title={title}
      description={description}
      okText={okText}
      cancelText={cancelText}
      okType={okType}
      cancelButtonProps={cancelButtonProps}
      okButtonProps={okButtonProps}
      icon={icon}
      showCancel={showCancel}
      onConfirm={onConfirm}
      onCancel={onCancel}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Popconfirm>
  );
};

export default MyPopconfirm;
